import { Button, message, Popconfirm, Table, Tag, Tooltip } from 'antd'
import {
    // EyeOutlined,
    EditOutlined,
    LockOutlined,
    UnlockOutlined,
} from '@ant-design/icons';

import { STATUS_DICT } from '../dict';
import { editUser } from '../service';

const UserTable = props => {
    const { setQuery, onEdit, onReload } = props
    const { data, query } = props

    const columns = [
        {
            title: '用户状态',
            dataIndex: 'status',
            align: 'center',
            fixed: 'left',
            render: text => {
                let dict = STATUS_DICT.find(i => i.key === text)
                return <Tag color={dict.color}>{dict.label}</Tag>
            }
        },
        {
            title: '昵称',
            dataIndex: 'nickName',
            align: 'center',
            width: 180,
        },
        {
            title: '手机号码',
            dataIndex: 'phone',
            align: 'center',
            width: 180,
        },
        {
            title: '年龄',
            dataIndex: 'age',
            align: 'center',
            width: 80,
            render: text => text || '-'
        },
        {
            title: '性别',
            dataIndex: 'gender',
            align: 'center',
            width: 80,
            render: text => text === 1 ? '男' : text === 0 ? '女' : '-'
        },
        {
            title: '身高',
            dataIndex: 'height',
            align: 'center',
            width: 100,
            render: text => !!text ? text + 'cm' : '-'
        },
        {
            title: '体重',
            dataIndex: 'weight',
            align: 'center',
            width: 100,
            render: text => !!text ? text + 'kg' : '-'
        },
        {
            title: '基础疾病',
            dataIndex: 'desc',
            align: 'center',
            width: 240,
            ellipsis: true,
            render: text => <div
                style={{
                    maxWidth: 240,
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                }}
            >
                {text || '-'}
            </div>
        },
        {
            title: '最后登录时间',
            dataIndex: 'lastLoginDate',
            align: 'center',
            width: 160,
            render: text => text || '-'
        },
        {
            title: '注册时间',
            width: 160,
            dataIndex: 'createdAt',
            align: 'center',
        },
        {
            title: '用户ID',
            dataIndex: 'id',
            align: 'center',
            width: 350,
        },
        {
            title: '操作',
            fixed: 'right',
            width: 120,
            dataIndex: 'op',
            align: 'center',
            render: (text, rcd) => <div>
                {/* <Tooltip title='查看用户'>
                    <Button size='small' icon={<EyeOutlined />} />
                </Tooltip> */}
                <Tooltip title='编辑用户'>
                    <Button
                        size='small'
                        icon={<EditOutlined />}
                        onClick={() => onEdit(rcd)}
                    />
                </Tooltip>
                <Tooltip title={rcd.status === 1 ? '冻结用户' : '解除冻结'}>
                    <Popconfirm
                        title={`确认${rcd.status === 1 ? '禁用' : '解禁'}用户吗`}
                        onConfirm={() => handleOnBan({
                            id: rcd.id,
                            status: rcd.status === 1 ? 2 : 1
                        })}
                    >
                        <Button
                            size='small'
                            icon={rcd.status === 1 ? <LockOutlined /> : <UnlockOutlined />}
                        />
                    </Popconfirm>
                </Tooltip>
            </div>
        }
    ]

    const handleOnChangeTable = (p, f, s, extra) => {
        if (extra.action === "paginate") {
            setQuery({
                ...query,
                pageNum: p.current,
                pageSize: p.pageSize
            })
        }
    }

    const handleOnBan = info => {
        editUser(info).then(res => {
            if (res.code === 200) {
                message.success('操作成功')
                onReload()
            }
        })
    }

    return <Table
        columns={columns}
        dataSource={data?.records || []}
        scroll={{ x: 'max-content', }}
        rowKey='id'
        size='small'
        pagination={{
            total: data?.total || 0,
            pageSize: data?.pageSize || 10,
            current: data?.pageNum || 1,
            pageSizeOptions: [10, 20, 50],
            showSizeChanger: true
        }}
        onChange={handleOnChangeTable}
    />
}

export default UserTable
